import { render, staticRenderFns } from "./Acordos.vue?vue&type=template&id=61aa4b80&"
import script from "./Acordos.vue?vue&type=script&lang=js&"
export * from "./Acordos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports